export enum GenericUploadStepEnum {
  Upload = "upload",
  Preview = "preview",
  Process = "process",
}
